import Vue from 'vue'
import {store} from "../store/store";

import Profile from '../pages/Profile'
import Main from "../layout/Main";
import Login from "../components/Auth/Login";
import Register from "../components/Auth/Register";
import ResetPassword from "../components/Auth/ResetPassword";
import ClientUsersList from "../pages/ClientUsersList";
import Drawer from "../layout/Drawer";
import ClientsList from "../pages/ClientsList";
import UsersAdmin from "../pages/UsersAdmin";
import PanelMonitoring from "../pages/Monitoring";
import Projects from "../pages/Projects";
import Community from "../pages/Community";
import ProjectOverview from "../pages/Project";
import NewProjectForm from "../components/Projects/NewProjectForm";
import DeleteConfirmation from "../components/DeleteConfirmation";

Vue.config.productionTip = false;

const guard = async (to, from, next) => {
    const hasPermission = await store.dispatch('authenticate');
    if (hasPermission) {
        next()
    } else {
        next({
            name: "Login",
            query: {redirectFrom: to.fullPath}
        })
    }
};

const routes = [
    {
        path: "",
        component: Main,
        redirect: "/login",
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        }
    },
    {
        path: '/clients',
        name: 'Clients',
        components: {
            default: ClientsList,
            'classic-drawer': Drawer
        },
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        }
    },
    {
        path: '/users',
        name: 'Users',
        components: {
            default: UsersAdmin,
            'classic-drawer': Drawer
        },
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        }

    },
    {
        path: '/monitoring',
        name: 'Monitoring',
        components: {
            default: PanelMonitoring,
            'classic-drawer': Drawer
        },
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        }
    },
    {
        path: '/clients/:id',
        params: ['id', 'name', 'avatarsColors', 'index'],
        name: 'Client',
        components: {
            default: ClientUsersList,
            'classic-drawer': Drawer
        },
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        components: {
            default: Profile,
            'classic-drawer': Drawer
        },
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        }
    },
    {
        path: '/projects',
        name: 'Projects',
        components: {
            default: Projects,
            'classic-drawer': Drawer
        },
        children: [
            {
                path: 'create',
                name: 'NewProjectForm',
                params: ['domain_id'],
                components: {
                    default: Projects,
                    'projects-form': NewProjectForm
                },
            },
            {
                path: 'delete',
                name: 'DeleteProjectConfirmation',
                params: ['id', 'type', 'name', 'returnToCompName'],
                components: {
                    default: Projects,
                    'projects-form': DeleteConfirmation
                },
            },
        ],
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        },
    },
    {
        path: '/projects/project/:projectId',
        name: 'ProjectOverview',
        components: {
            default: ProjectOverview,
            'classic-drawer': Drawer
        },
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        },
    },
    {
        path: '/community',
        name: 'Community',
        params: ['dialog'],
        components: {
            default: Community,
            'classic-drawer': Drawer
        },
        beforeEnter(to, from, next) {
            return guard(to, from, next)
        },
    },
    {
        path: '/login',
        name: 'Login',
        components: {
            default: Login,
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
    },
    {
        path: '/reset-password',
        name: 'Reset password',
        component: ResetPassword,
    },
    {
        path: '*',
        redirect: '',
    }
];

export default routes;
